enum FIELDS_COMPONENTS {
  AMOUNT_UNIT = 'AMOUNT_UNIT',
  ANIMAL_BIRTHDAY = 'ANIMAL_BIRTHDAY',
  ANIMAL_NAME = 'ANIMAL_NAME',
  ANIMAL_TEMPLATE = 'ANIMAL_TEMPLATE',
  BOOSTER = 'BOOSTER',
  BUTTON_CHECKBOX = 'BUTTON_CHECKBOX',
  CARD_READER = 'CARD_READER',
  CASH_PAYMENT = 'CASH_PAYMENT',
  CHECKBOX = 'CHECKBOX',
  CHECK_NUMBER = 'CHECK_NUMBER',
  COLOR_SELECTOR = 'COLOR_SELECTOR',
  CONTACT = 'CONTACT',
  CONTACT_TYPE = 'CONTACT_TYPE',
  COST_UNIT = 'COST_UNIT',
  COUNTRY = 'COUNTRY',
  DATE = 'DATE',
  DATE_PICKER = 'DATE_PICKER',
  DROPDOWN = 'DROPDOWN',
  DONATION_AMOUNT = 'DONATION_AMOUNT',
  EDITOR = 'EDITOR',
  EMAIL = 'EMAIL',
  FIELD_STRING = 'FIELD_STRING',
  FILE = 'FILE',
  FREQUENCY = 'FREQUENCY',
  GMAP = 'GMAP',
  GROUP = 'GROUP',
  HEADER = 'HEADER',
  HOLD_STATUS = 'HOLD_STATUS',
  INTAKE_WAIVERS = 'INTAKE_WAIVERS',
  KENNEL_MANAGER = 'KENNEL_MANAGER',
  LINK = 'LINK',
  LOCATION = 'LOCATION',
  MICROCHIP = 'MICROCHIP',
  MICROCHIP_ISSUER = 'MICROCHIP_ISSUER',
  MONEY = 'MONEY',
  MULTISELECT = 'MULTISELECT',
  NUMBER = 'NUMBER',
  PARAGRAPH = 'PARAGRAPH',
  PASSWORD = 'PASSWORD',
  PHONE_CARD = 'PHONE_CARD',
  PROFILE_INFO = 'PROFILE_INFO',
  OPEN_MODAL = 'OPEN_MODAL',
  PRINT = 'PRINT',
  RADIO = 'RADIO',
  RESULT = 'RESULT',
  SEPARATOR = 'SEPARATOR',
  SPECIES = 'SPECIES',
  SPLIT_PAYMENT = 'SPLIT_PAYMENT',
  STAFF = 'STAFF',
  STRIPE = 'STRIPE',
  TAG = 'TAG',
  TEL = 'TEL',
  TEXT = 'TEXT',
  TEXTAREA = 'TEXTAREA',
  TIMEFRAME = 'TIMEFRAME',
  TOGGLE = 'TOGGLE',
  WEIGHT = 'WEIGHT',
}

enum FORM_VALIDATIONS {
  MAX_LENGTH = 'MAX_LENGHT',
  MIN_LENGTH = 'MIN_LENGHT',
}

export { FIELDS_COMPONENTS, FORM_VALIDATIONS };
